
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"r":"12","cx":"12","cy":"12","fill":"var(--brand-primary)"}}),_c('path',{attrs:{"fill":"var(--brand-primary-invert)","d":"M15.5 6.5h-7A2.503 2.503 0 006 9v6a2.503 2.503 0 002.5 2.5h7A2.503 2.503 0 0018 15V9a2.503 2.503 0 00-2.5-2.5zm-7 1h7a1.5 1.5 0 011.39.944l-3.829 3.829a1.504 1.504 0 01-2.122 0L7.11 8.443A1.5 1.5 0 018.5 7.5zm7 9h-7A1.5 1.5 0 017 15V9.75l3.232 3.23a2.503 2.503 0 003.536 0L17 9.75V15a1.5 1.5 0 01-1.5 1.5z"}})])
          )
        }
      }
    